<kendo-formfield>
    <div class="k-form-field-checkbox-wrap" >
        <input kendoCheckBox
        [ngClass]=" isLarge ? 'large-checkbox' :''"
        [id]="formControlName"
        type="checkbox"
        [formControl]="control"
        (change)="onChange($event)"
        />
        <kendo-label class="k-checkbox-label" [for]="formControlName" [text]="caption | translate"
        ></kendo-label>     
    </div>
</kendo-formfield>
